module.exports = __webpack_public_path__ + "static/img/20.0f008c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/20.png
// module id = 6MIH
// module chunks = 10